module.exports = __webpack_public_path__ + "img/bottom-stage.f723c49d.png";